import { Box, useRadio } from '@chakra-ui/react';

export default function RadioCard(props: React.HTMLAttributes<HTMLDivElement>) {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <Box as="label">
      <input {...input} />
      <Box
        {...checkbox}
        cursor="pointer"
        borderWidth="1px"
        borderRadius="md"
        boxShadow="md"
        _checked={{
          bg: 'teal.400',
          color: 'white',
          borderColor: 'teal.400',
        }}
        _focus={{
          boxShadow: 'md',
        }}
        px={5}
        py={3}
      >
        {props.children}
      </Box>
    </Box>
  );
}
